export default "__VITE_ASSET__RKwG6aY0__"